Ext.define('SA.VectorMapExportNorthArrowOverlay', {
    alias: 'widget.vector-map-export-north-arrow-overlay',
    extend: 'Ext.Component',

    cls: 'sa-vector-map-export-overlay',
    constrain: true,
    draggable: true,
    floating: true,
    height: 500,
    overCls: 'sa-vector-map-export-overlay-over',
    toFrontOnShow: false,
    width: 270,

    resizable: {
        preserveRatio: true,
        transparent: true
    },

    getRecord() {
        return this.details.getNorthArrow();
    },

    refresh() {
        var params = SA.VectorMapExportParams.forNorthArrow({details: this.details, pageWidth: this.page.getWidth()});

        this.svg?.remove();
        this.svg = this.getEl().dom.appendChild(SA.VectorMapExportNorthArrow.getSvg(params));
    }
});